import { inject } from '@angular/core';
import { CanMatchFn, UrlSegment } from '@angular/router';
import { map } from 'rxjs/operators';
import { PublicProductRouteResolverService } from '../services/public-product-route-resolver.service';

interface PublicProductRouteParams {
  login: string;
  identifier: string;
}

function extractParams(segments: UrlSegment[]): PublicProductRouteParams | null {
  if (!segments || segments.length !== 2) {
    return null;
  }

  const [loginSegment, identifierSegment] = segments;
  if (!loginSegment.path.startsWith('@') || loginSegment.path.length <= 1 || !identifierSegment.path) {
    return null;
  }

  const decode = (value: string): string => {
    try {
      return decodeURIComponent(value).trim();
    } catch {
      return value.trim();
    }
  };

  const login = decode(loginSegment.path.slice(1));
  const identifier = decode(identifierSegment.path);
  if (!login || !identifier) {
    return null;
  }

  return {
    login,
    identifier
  };
}

export const canMatchSubscriptionPublicProduct: CanMatchFn = (_route, segments) => {
  const params = extractParams(segments);
  if (!params) {
    return false;
  }

  const resolver = inject(PublicProductRouteResolverService);
  return resolver.resolveType(params.login, params.identifier).pipe(
    map((type) => type === 'subscription')
  );
};

export const canMatchDigitalProductPublicProduct: CanMatchFn = (_route, segments) => {
  const params = extractParams(segments);
  if (!params) {
    return false;
  }

  const resolver = inject(PublicProductRouteResolverService);
  return resolver.resolveType(params.login, params.identifier).pipe(
    map((type) => type === 'digitalProduct')
  );
};
